<template>
    <section class="app-main">
        
        <el-tabs type="border-card" style="margin-top:30px;">
            <el-tab-pane label="主题管理">
                <banner section="5" :size="size" />
            </el-tab-pane>
            <el-tab-pane label="分类管理">
                <classify section="5" :classify.sync="classify" :place_holder="place_holder" />
            </el-tab-pane>
            <el-tab-pane label="折扣商品(中英文)">
                <goods section="5" :classify="classify" />
            </el-tab-pane>
            <!-- <el-tab-pane label="签到商品(中文)">
                <sign-goods section="5" :classify="classify" />
            </el-tab-pane> -->
            <el-tab-pane label="本月签到统计">
                <sign />
            </el-tab-pane>
        </el-tabs>

    </section>
</template>



<script>
import Banner   from './../components/banner'
import Classify from './../components/class'
import Goods    from './../components/goods'
// import SignGoods    from './components/goods'
import Sign    from './components/sign'
export default {
    // SignGoods
    components: { Banner, Classify, Goods, Sign },
    data() {
        return {
            classify: [],
            size: '375*260',
            place_holder: "（*建议尺寸343*182）"
        }
    },
    methods: {
        
        
    },
    created(){
        // this.getData()
    }
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        font-size: 16px;
    }
}
</style>
